import React, {Component, Fragment} from "react";
import {Button, Card, CardBody, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Tooltip} from "reactstrap";
import TransactionStatus from "../../domain/Transaction/TransactionStatus";
import "../../views/Authenticated/Transactions/transaction.css";
import "flag-icon-css/css/flag-icon.css";
import SFXLoadingComponent from "../SFXLoadingComponent";
import QuotationRequestService from "../../services/Transaction/QuotationRequestService";
import ToastHelper from "../../utils/ToastHelper";
import InboundTransactionService from "../../services/Transaction/inbound/InboundTransactionService";
import InboundPaymentService from "../../services/Transaction/inbound/InboundPaymentService";
import SystemConfigService from "../../services/SystemConfigService";
import UserSessionService from "../../services/UserSessionService";
import DigiPayPayNowButton from "./outbound/DigiPayPayNowButton";
import TransactionService from "services/Transaction/TransactionService";
import SFXRoundedButton from "components/SFXRoundedButton";
import PaymentOptions from "./outbound/PaymentOptions";
import PaymentOptionsService from "../../services/payment/PaymentOptionsService";
import ResendPaymentReferenceService from "../../services/Transaction/ResendPaymentRefService"

let INBOUND_FIELDS_LIST = ["BANKNAME", "BANKACCOUNTNO", "BANKBRANCHNO"];

const DECLARATION_LINK = process.env.REACT_APP_DECLARATION_LINK;
const HOW_TO_PAY_LINK = process.env.REACT_APP_HOW_TO_PAY_LINK;
const T_AND_C_LINK = process.env.REACT_APP_T_AND_C_LINK;
const NETCASH_URL = process.env.REACT_APP_NETCASH_URL;
const NETCASH_M1 = process.env.REACT_APP_NETCASH_M1;
const NETCASH_M2 = process.env.REACT_APP_NETCASH_M2;
const SFX_EFT_EMAIL = process.env.REACT_APP_SFX_EFT_EMAIL;

export default class TransactionCard extends Component {

    constructor(props, context) {
        super(props, context);

        this.customerEmail = UserSessionService.getCustomerProfile().emailAddress;
        this.customerMsisdn = UserSessionService.getCustomerProfile().msisdnValue;

        this.state = {
            modalOpen: false,
            quotationRequest: undefined,
            inboundTransactionData: undefined,
            paymentRequest: undefined,
            toolTipOpen: false,
            isPayNowActive: false,

            paymentOptions: [],
            showPaymentOptions: false
        };

        this.initialEvent = true;

    }

    loadDetails() {
        let requestCalls = [];
        requestCalls.push(QuotationRequestService.retrieveQuotationRequestByTransactionId(this.props.transactionData.transactionId))
        requestCalls.push(SystemConfigService.retrieveConfigEntry('PAY_NOW_BUTTON_ACTIVE'))
        requestCalls.push(PaymentOptionsService.retrievePaymentOptions())

        Promise.all(requestCalls).then(response => {

            let newState = {};

            if (response[0].id) {
                newState.quotationRequest = response[0];
            } else {
                ToastHelper.formatError(response);
                newState.modalOpen = false;
                newState.quotationRequest = undefined;
            }
            if (response[1].id) {
                newState.isPayNowActive = response[1].value === 'true';
            }
            if (Array.isArray(response[2])) {
                newState.paymentOptions = response[2]
            }

            this.setState(newState);
        });
    }

    loadInboundDetails() {

        InboundTransactionService.retrieve(this.props.transactionData.transactionId).then(response => {

            let newState = {
                modalOpen: false,
                inboundTransactionData: undefined,
                paymentRequest: undefined
            };

            if (response) {
                newState.inboundTransactionData = response;
                newState.modalOpen = true;

                if (response.inboundTransactionStatus === 'ALLOCATED_PAID') {
                    InboundPaymentService.retrieveByTransactionId(this.props.transactionData.transactionId).then(paymentData => {
                        if (paymentData.id) {
                            newState.paymentRequest = paymentData
                        }
                        this.setState(newState);
                    });
                } else {
                    this.setState(newState);
                }
            } else {
                this.setState(newState);
                ToastHelper.formatError(response);
            }
        });
    }

    onCardClick() {
        let newState = {modalOpen: true};
        if (this.state.quotationRequest) {
            this.setState(newState);
        } else {
            this.setState(newState, this.loadDetails);
        }
    }

    onCardClickInbound() {
        this.loadInboundDetails()
    }

    onModalClose() {
        this.setState({modalOpen: false});
    }

    btnCancelTransactionClick() {
        this.setState({showTransactionCancelModal: true});
    }

    btnCancelTransactionConfirmClick() {
        TransactionService.expireTransactionByTransactionId(this.props.transactionData.transactionId).then(response => {
            if (response === "OK") {
                this.setState({
                    showTransactionCancelModal: false,
                }, this.props.doRefresh);
            } else {
                ToastHelper.formatError(response);
            }
        })
    }

    getDateNow() {
        let now = new Date(Date.now())

        let todayDate = {
            "yyyy": now.getFullYear(),
            "mm": (now.getMonth() + 1).toString().length === 2 ? (now.getMonth() + 1) : "0" + (now.getMonth() + 1),
            "dd": now.getDate(),
            "hh": now.getHours(),
            "m": now.getMinutes()
        }

        return todayDate["yyyy"] + "" + todayDate["mm"] + "" + todayDate["dd"] + "" + todayDate["hh"] + "" + todayDate["m"];
    }

    getEmail() {
        if (this.customerEmail) {
            return this.customerEmail;
        } else {
            return SFX_EFT_EMAIL;
        }
    }

    getMsisdn() {
        if (!this.customerEmail) {
            return this.strip27();
        } else {
            if (this.customerMsisdn.startsWith("270")) {
                return "";
            } else {
                return this.strip27();
            }
        }
    }

    strip27() {
        return "0" + this.customerMsisdn.slice(2);
    }

    onSubmit(event) {
        if (this.initialEvent) {
            this.initialEvent = false;
            event.preventDefault();

            document.getElementById("M1").value = NETCASH_M1;
            document.getElementById("M2").value = NETCASH_M2;
            document.getElementById("p2").value = this.props.transactionData.paymentReference + this.getDateNow();
            document.getElementById("p3").value = "Product Description";
            document.getElementById("p4").value = this.props.transactionData.amount;
            document.getElementById("Budget").value = "N";
            document.getElementById("m4").value = this.props.transactionData.paymentReference;
            document.getElementById("m5").value = this.props.transactionData.transactionId;
            document.getElementById("m9").value = this.getEmail();
            document.getElementById("m11").value = this.getMsisdn();

            setTimeout(() => {
                document.getElementById("btn_submit").click();

            }, 250);
        }
    }

    render() {
        return <Fragment>
            {this.renderTransactionCards(this.props.transactionData)}
            {this.state.modalOpen && this.renderModal(this.props.transactionData.transactionType)}
        </Fragment>
    }

    renderTransactionCards(transaction) {
        return <Fragment>
            <Card style={{border: "none"}} onClick={(event) => {
                if (transaction.transactionType === "OUTBOUND") {
                    this.onCardClick(event)
                } else {
                    this.onCardClickInbound(event)
                }
            }}>
                <CardBody>
                    <div style={{padding: "4px 8px", display: "flex", margin: "auto", width: "100%", fontSize: "11pt"}}>
                        {this.renderHeader(transaction)}
                    </div>
                </CardBody>
            </Card>
            <hr/>
        </Fragment>
    }

    renderModalOutboundTransactionCard(transaction, quotationRequest, isPayNowActive) {
        if (this.state.showPaymentOptions) {
            return this.renderPaymentOptions(transaction, this.state.paymentOptions)
        }
        return <Fragment>
            <div style={{padding: "4px 8px", display: "flex", margin: "auto", width: "100%", fontSize: "11pt"}}>
                {this.renderHeader(transaction)}
            </div>
            <br/>
            <Fragment>
                {transaction.collectionPin.length > 0 && this.renderLabelValue("Collection Pin: ", transaction.collectionPin)}
                {this.renderLabelValue("Payout Method: ", quotationRequest.payoutMethod)}
                {this.renderLabelValue("Payout Partner: ", quotationRequest.payoutPartnerName)}
                {this.renderLabelValue("Fees: ", transaction.fees)}
                {this.renderLabelValue("VAT: ", transaction.vat)}
                {transaction.paymentReference.length > 0 && this.renderPaymentReferenceRow(transaction.transactionId)} 

            </Fragment>
            {transaction.status === "APPROVED_UNPAID" && isPayNowActive === 'true' && this.renderNetcash()}
            {transaction.status === "APPROVED_UNPAID" && this.state.paymentOptions.length > 0 && this.renderPayNow()}
            {(transaction.status === "APPROVED_UNPAID" || transaction.status === "CREATED") && this.renderCancelTransactionButton()}


            <hr/>
            <Fragment>
                <div style={{display: "flex", flex: 3}}>
                    {this.renderDeclarationFooter("left", 0, DECLARATION_LINK, "Declaration")}
                    {this.renderDeclarationFooter("center", "42px", HOW_TO_PAY_LINK, "How To Pay")}
                    {this.renderDeclarationFooter("right", 0, T_AND_C_LINK, "Terms & Conditions")}
                </div>
            </Fragment>
        </Fragment>
    }

    renderDeclarationFooter(textAlign, padding, ref, label) {
        let fontSize = "10pt";
        if (this.props.isMobile === "mobile") {
            fontSize = "8pt";
        }
        return <div style={{fontSize: fontSize, paddingRight: padding, flex: 1, textAlign: textAlign}}>
            <a className={"declaration_footer"} target="_blank" rel="noopener noreferrer" href={ref}>{label}</a>
        </div>
    }

    renderResendSMSLink(transactionId) {
        const isLoading = this.state.resendLoadingTransactionId === transactionId;

        return (
            <div style={{ fontSize: "10pt", paddingLeft: 5, flex: 1, textAlign: "left" }}>
                {isLoading ? (
                    <i className="fa fa-spinner fa-spin" style={{ color: "orange", fontSize: "12pt" }}></i>
                ) : (
                    <a
                        className="declaration_footer"
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            this.setState({ resendLoadingTransactionId: transactionId });
                            ResendPaymentReferenceService.resendPaymentReference(transactionId)
                                .then(() => {
                                    ToastHelper.success("An SMS with Payment Reference has been sent to " + this.customerMsisdn);
                                    this.setState({ resendLoadingTransactionId: null });
                                })
                                .catch((error) => {
                                    ToastHelper.formatError(error);
                                    this.setState({ resendLoadingTransactionId: null });
                                });
                        }}
                    >
                        Resend
                    </a>
                )}
            </div>
        );
    }



    renderModalInboundTransactionCard(transaction, inboundTransaction, paymentRequest) {
        let providedFields = {};
        inboundTransaction.providedFields.forEach((field) => {
            if (INBOUND_FIELDS_LIST.includes((field.providedFieldName).toUpperCase())) {
                providedFields[(field.providedFieldName).toUpperCase()] = field;
            }
        });
        return <Fragment>
            <div style={{padding: "4px 8px", display: "flex", margin: "auto", width: "100%", fontSize: "11pt"}}>
                {this.renderHeader(transaction)}
            </div>
            <br/>
            <Fragment>
                {inboundTransaction.collectionPin.length > 0 && this.renderLabelValue("Collection Pin: ", inboundTransaction.collectionPin)}
                {inboundTransaction.inboundTransactionTypeDisplayValue && this.renderLabelValue("Transaction Type: ", inboundTransaction.inboundTransactionTypeDisplayValue)}
                {paymentRequest && this.renderPaymentDateValue("Payment Date: ", paymentRequest, inboundTransaction.inboundTransactionType)}

                {INBOUND_FIELDS_LIST.map((key) => {
                    let field = providedFields[key];
                    if (field !== undefined) {
                        return <Fragment key={key}>
                            {this.renderLabelValue(field.providedFieldDisplayName + ": ", field.requiredFieldValue)}
                        </Fragment>
                    } else {
                        return <Fragment key={key}></Fragment>
                    }
                })}
            </Fragment>
        </Fragment>
    }

    renderLabelValue(label, value) {
        return <div style={{fontSize: "14px"}}><span style={{fontWeight: "bold"}}>{label}</span> {value}
        </div>
    }

     renderPaymentReferenceRow(transactionId) {
        return <div style={{fontSize: "14px", display:"flex", flexDirection:"row", marginBottom:"15px"}}>
            <span style={{fontWeight: "bold"}}>Payment Reference:</span>Sent via SMS
            {this.renderResendSMSLink(transactionId)}
            </div>
            } 

    toggle() {
        this.setState({toolTipOpen: !this.state.toolTipOpen})
    }

    renderPaymentDateValue(label, paymentRequest, transactionType) {
        return <div style={{fontSize: "14px"}}><span style={{fontWeight: "bold"}}>{label}</span>
            {paymentRequest.requestDate}
            &nbsp;
            <Fragment>
                <span style={{color: "grey"}} className="fa fa-info-circle" aria-hidden="true" id="paymentInfo"></span>
                <Tooltip placement="top" isOpen={this.state.toolTipOpen} target="paymentInfo"
                         toggle={this.toggle.bind(this)} style={{textAlign: "left"}}>
                    {this.getMessage(paymentRequest, transactionType)}
                </Tooltip>
            </Fragment>
        </div>
    }

    getMessage(paymentRequest, transactionType) {
        if (transactionType === 'CASH') {
            return "Cash voucher has been sent."
        } else {
            if (paymentRequest.paymentTimeFrame === 'IMMEDIATE') {
                return "Payment should reflect immediately."
            } else {
                return <span style={{textAlign: "left"}}>- Payments before 3pm should reflect before midnight.<br/>
                    - Payments after 3pm should reflect before midnight the next day.<br/>
                    - Weekend Payments should reflect before midnight on Monday.</span>

            }
        }
    }

    renderHeader(transaction) {

        return <Fragment>
            <div style={{display: "flex", margin: "auto", width: "100%", flex: "6"}}>
                <div style={{
                    marginRight: "15px",
                    minWidth: "60px",
                    minHeight: "60px",
                    margin: "auto",
                    paddingTop: "3px"
                }}>
                <span className={"flag-icon flag-icon-" + transaction.beneficiaryCountryISO2}
                      title={transaction.countryDisplayValue}
                      style={{flex: "1", borderRadius: "30%", minWidth: "45px", minHeight: "45px"}}/>
                </div>
                <div style={{display: "-ms-flexbox", flex: "2", margin: "auto"}}>
                    <div style={{flex: "1", maxWidth: "100%", margin: "auto", fontSize: "10pt"}}>
                        <b>{transaction.fullName}</b>
                    </div>
                    <div style={{flex: "1", margin: "auto", display: "flex"}}>
                        <div style={{justifyContent: "right"}}>
                            <div style={{flex: "1", color: "#484848", fontSize: "9pt"}}>
                                {transaction.displayDate}
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{width: "100%", margin: "auto", textAlign: "center", fontSize: "10pt", flex: "2"}}>
                    <b style={{marginRight: "10px"}}>R {transaction.amount}</b>
                    {
                        transaction.transactionType === "OUTBOUND"
                        &&
                        <Fragment>
                            <i className={"fa fa-arrow-right"}
                               style={{color: "red"}}/>
                            <b style={{
                                color: "green",
                                marginLeft: "10px"
                            }}>{transaction.currency} {transaction.destinationAmount}</b>
                        </Fragment>
                    }
                </div>

                <div style={{display: "-ms-flexbox", flex: "2", margin: "auto"}}>
                    <div style={{flex: "1", textAlign: "right"}}>
                        {this.renderTransactionType(transaction.transactionType)}
                    </div>
                    <div style={{flex: "1", textAlign: "right"}}>
                        {TransactionStatus.getStatus(transaction.status)}
                    </div>
                </div>

            </div>
        </Fragment>
    }

    renderTransactionType(type) {
        return <Fragment>
            {type === "OUTBOUND" ?
                <Fragment>
                    <i className="fa fa-arrow-right" style={{color: "#124892"}}></i> Sent
                </Fragment>
                :
                <Fragment>
                    <i className="fa fa-arrow-left" style={{color: "#124892"}}></i> Received
                </Fragment>
            }
        </Fragment>
    }

    renderModal(transactionType) {
        return <Modal isOpen={true} toggle={this.onModalClose.bind(this)}>
            <ModalBody>
                {transactionType === "OUTBOUND" ?
                    this.state.quotationRequest ? (this.renderModalOutboundTransactionCard(this.props.transactionData, this.state.quotationRequest, this.state.isPayNowActive)) :
                        <SFXLoadingComponent size={"small"}/>
                    :
                    this.renderModalInboundTransactionCard(this.props.transactionData, this.state.inboundTransactionData, this.state.paymentRequest)
                }
            </ModalBody>
            <ModalFooter>
                {
                    this.state.showPaymentOptions
                        ? <Button onClick={() => this.setState({showPaymentOptions: false})}>Back</Button>
                        : <Button onClick={this.onModalClose.bind(this)}>Back</Button>
                }
            </ModalFooter>
        </Modal>
    }

    renderNetcash() {
        return <Fragment>
            <br/>
            <div style={{margin: "auto", textAlign: "center", marginBottom: "2px"}}>
                <Form
                    name="form" id="x1" method="POST" action={NETCASH_URL}
                    target="_top"
                    onSubmit={this.onSubmit.bind(this)}>
                    <Input type="hidden" id="M1" name="M1" value=""/>
                    <Input type="hidden" id="M2" name="M2" value=""/>
                    <Input type="hidden" id="p2" name="p2" value=""/>
                    <Input type="hidden" id="p3" name="p3" value=""/>
                    <Input type="hidden" id="p4" name="p4" value=""/>
                    <Input type="hidden" id="Budget" name="Budget" value=""/>
                    <Input type="hidden" id="m4" name="m4" value=""/>
                    <Input type="hidden" id="m5" name="m5" value=""/>
                    <Input type="hidden" id="m9" name="m9" value=""/>
                    <Input type="hidden" id="m11" name="m11" value=""/>
                    <Input id="btn_submit" name="submit"
                           type="submit"
                           className={"browser_orange_oval_button"}
                           style={{color: "white", margin: "auto"}}
                           value="Pay Now"/>
                </Form>
            </div>
        </Fragment>;
    }

    renderCancelTransactionButton() {
        return <Fragment>
            <div style={{margin: "auto", textAlign: "center", marginBottom: "2px"}}>
                <SFXRoundedButton className={"cancel_transaction_btn"}
                    value="Cancel Transaction"
                    onClick={this.btnCancelTransactionClick.bind(this)}
                />
            </div>
            {this.state.showTransactionCancelModal && this.returnTransactionCancelModal()}
        </Fragment>;
    }

    returnTransactionCancelModal() {
        return <Fragment>
            <Modal isOpen={true}
                   className={'modal-danger modal-sm ' + this.props.className}>
                <ModalHeader>Cancel Transaction</ModalHeader>
                <ModalBody>
                    Are you sure you want to cancel this transaction?
                </ModalBody>
                <ModalFooter>
                    <Button color="danger"
                            type={"button"}
                            onClick={this.btnCancelTransactionConfirmClick.bind(this)}
                    >
                        Yes</Button>{' '}
                    <Button color="secondary"
                            type={"button"}
                            onClick={() => {
                                this.setState({showTransactionCancelModal: false})
                            }}>No</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    }

    renderDigiPayPayNow(transactionId) {
        return <Fragment>
            <div style={{margin: "auto", textAlign: "center", padding: 10}}>
                <DigiPayPayNowButton
                    transactionId={transactionId}
                />
            </div>
        </Fragment>
    }

    renderPayNow() {
        return <Fragment>
            <SFXRoundedButton
                style={{marginBottom: '5px'}}
                value='Pay Now'
                onClick={() => {
                    this.setState({showPaymentOptions: true})
                }}
            />
        </Fragment>
    }

    renderPaymentOptions(transaction, paymentOptions) {
        return <PaymentOptions
            transaction={transaction}
            isMobile={this.props.isMobile}
            paymentOptions={paymentOptions}
            doRefresh={this.doRefresh.bind(this)}
        />
    }

    doRefresh(){
        this.onModalClose();
        if(this.props.doRefresh){
            this.props.doRefresh()
        }
    }
}
